<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication">
<p class="ded"><span epub:type="pagebreak" id="page_6" title="6"><i>For my family</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Dedicaption.vue?54e759ea